import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInput = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 4C20 4 22 5.00092 22 12.0005C22 19 20 20 12 20C4 20 2 18.9231 2 12.0005C2 5.07784 4 4 12 4Z",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 9H8M9.5 9H8M8 9V15M8 15H9.5M8 15H6.5",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgInput);
export { ForwardRef as ReactComponent };
